/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsTournamentidReplayMetricsQueryResponse,
  GetTournamentsTournamentidReplayMetricsPathParams,
  GetTournamentsTournamentidReplayMetrics404,
} from "../types/GetTournamentsTournamentidReplayMetrics.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsTournamentidReplayMetricsQueryKey = (
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPathParams["tournamentId"]
    | undefined,
) =>
  [
    {
      url: "/tournaments/:tournamentId/replay-metrics",
      params: { tournamentId: tournamentId },
    },
  ] as const;

export type GetTournamentsTournamentidReplayMetricsQueryKey = ReturnType<
  typeof getTournamentsTournamentidReplayMetricsQueryKey
>;

/**
 * @summary Метрики всех игроков турнира. Пустой список — реплеев ещё нет либо ни один не
 * разобрался; это не ошибка, витрина просто не рисует блок.
 * {@link /tournaments/:tournamentId/replay-metrics}
 */
export async function getTournamentsTournamentidReplayMetrics(
  tournamentId: GetTournamentsTournamentidReplayMetricsPathParams["tournamentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsTournamentidReplayMetricsQueryResponse,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetrics404>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${tournamentId}/replay-metrics`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsTournamentidReplayMetricsQueryOptions(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPathParams["tournamentId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getTournamentsTournamentidReplayMetricsQueryKey(tournamentId);
  return queryOptions<
    ResponseConfig<GetTournamentsTournamentidReplayMetricsQueryResponse>,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetrics404>,
    ResponseConfig<GetTournamentsTournamentidReplayMetricsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!tournamentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsTournamentidReplayMetrics(tournamentId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Метрики всех игроков турнира. Пустой список — реплеев ещё нет либо ни один не
 * разобрался; это не ошибка, витрина просто не рисует блок.
 * {@link /tournaments/:tournamentId/replay-metrics}
 */
export function useGetTournamentsTournamentidReplayMetrics<
  TData = ResponseConfig<GetTournamentsTournamentidReplayMetricsQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsTournamentidReplayMetricsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsTournamentidReplayMetricsQueryKey,
>(
  tournamentId:
    | GetTournamentsTournamentidReplayMetricsPathParams["tournamentId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsTournamentidReplayMetricsQueryResponse>,
        ResponseErrorConfig<GetTournamentsTournamentidReplayMetrics404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTournamentsTournamentidReplayMetricsQueryKey(tournamentId);

  const query = useQuery(
    {
      ...getTournamentsTournamentidReplayMetricsQueryOptions(
        tournamentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTournamentsTournamentidReplayMetrics404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
